import { render, staticRenderFns } from "./Desarrollado.vue?vue&type=template&id=088cd0cc"
import script from "./Desarrollado.vue?vue&type=script&lang=js"
export * from "./Desarrollado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports